import { render, staticRenderFns } from "./ActiveEvent.vue?vue&type=template&id=f172baa2&scoped=true&"
import script from "./ActiveEvent.vue?vue&type=script&lang=js&"
export * from "./ActiveEvent.vue?vue&type=script&lang=js&"
import style0 from "./ActiveEvent.vue?vue&type=style&index=0&id=f172baa2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f172baa2",
  null
  
)

export default component.exports